/* eslint no-underscore-dangle: ["error", { "allow": ["_id", "_items"] }] */
import imm from 'object-path-immutable';
import { handleActions } from 'redux-actions';
import _ from 'lodash';
import {
  API_WILL_CREATE,
  API_CREATED,
  API_CREATE_FAILED,
  API_WILL_READ,
  API_READ,
  API_READ_FAILED,
  API_WILL_UPDATE,
  API_UPDATED,
  API_UPDATE_FAILED,
  API_WILL_DELETE,
  API_DELETED,
  API_DELETE_FAILED,
  IS_UPDATING,
  IS_DELETING,
} from '@keypr/redux-json-api/lib/constants';
import {
  removeResourceFromState,
  updateOrInsertResourcesIntoState,
  setIsInvalidatingForExistingResource,
  ensureResourceTypeInState,
} from '../../utils/state-mutation-ticket';
import {
  RESET_AFFILIATE,
  USER_LOGOUT,
  API_CLEAR,
} from '../types';

const API_PREFIX = 'menu';

const defaultState = {
  isCreating: 0,
  isReading: 0,
  isUpdating: 0,
  isDeleting: 0,
};

const menu = handleActions({
  [API_WILL_CREATE]: (state, { payload: { endpoint } }) => {
    if (endpoint.substring(0, 4) === API_PREFIX) {
      return imm(state).set(['isCreating'], state.isCreating + 1).value();
    }
    return state;
  },

  [API_CREATED]: (state, { payload: { resource, endpoint } }) => {
    if (endpoint.substring(0, 4) === API_PREFIX) {
      const type = endpoint.split(/\W+/)[1];
      const resources = (
        (_.has(resource, '_items') && Array.isArray(resource._items))
          ? resource._items
          : [resource]
      );

      const newState = updateOrInsertResourcesIntoState(state, resources, type);

      return imm(newState)
        .set('isCreating', state.isCreating - 1)
        .value();
    }
    return state;
  },

  [API_CREATE_FAILED]: (state, { payload: { endpoint } }) => {
    if (endpoint.substring(0, 4) === API_PREFIX) {
      return imm(state).set(['isCreating'], state.isCreating - 1).value();
    }
    return state;
  },

  [API_WILL_READ]: (state, { payload: { endpoint } }) => {
    if (endpoint.substring(0, 4) === API_PREFIX) {
      return imm(state).set(['isReading'], state.isReading + 1).value();
    }
    return state;
  },

  [API_READ]: (state, { payload: { resource, endpoint } }) => {
    if (endpoint.substring(0, 4) === API_PREFIX) {
      const type = endpoint.split(/\W+/)[1];
      const resources = (
        (_.has(resource, '_items') && Array.isArray(resource._items))
          ? resource._items
          : [resource]
      );

      const finalState = updateOrInsertResourcesIntoState(state, resources, type);

      return imm(finalState)
        .set('isReading', state.isReading - 1)
        .value();
    }
    return state;
  },

  [API_READ_FAILED]: (state, { payload: { endpoint } }) => {
    if (endpoint.substring(0, 4) === API_PREFIX) {
      return imm(state).set(['isReading'], state.isReading - 1).value();
    }
    return state;
  },

  [API_WILL_UPDATE]: (state, { payload: { endpoint, options: { urlParams } } }) => {
    if (endpoint.substring(0, 4) === API_PREFIX) {
      const type = endpoint.split(/\W+/)[1];
      const { _id } = urlParams;

      const newState = ensureResourceTypeInState(state, type);

      return setIsInvalidatingForExistingResource(newState, { type, _id }, IS_UPDATING)
        .set('isUpdating', state.isUpdating + 1)
        .value();
    }
    return state;
  },

  [API_UPDATED]: (state, { payload: { resource, endpoint } }) => {
    if (endpoint.substring(0, 4) === API_PREFIX) {
      const type = endpoint.split(/\W+/)[1];
      const resources = (
        (_.has(resource, '_items') && Array.isArray(resource._items))
          ? resource._items
          : [resource]
      );

      const newState = updateOrInsertResourcesIntoState(state, resources, type);

      return imm(newState)
        .set('isUpdating', state.isUpdating - 1)
        .value();
    }
    return state;
  },

  [API_UPDATE_FAILED]: (state, { payload: { resource, endpoint } }) => {
    if (endpoint.substring(0, 4) === API_PREFIX) {
      const type = endpoint.split(/\W+/)[1];
      const { _id } = resource;

      return setIsInvalidatingForExistingResource(state, { type, _id }, IS_UPDATING)
        .set('isUpdating', state.isUpdating + 1)
        .value();
    }
    return state;
  },

  [API_WILL_DELETE]: (state, { payload: { resource, endpoint } }) => {
    if (endpoint.substring(0, 4) === API_PREFIX) {
      const type = endpoint.split(/\W+/)[1];
      const { _id } = resource;

      return setIsInvalidatingForExistingResource(state, { type, _id }, IS_DELETING)
        .set('isDeleting', state.isDeleting + 1)
        .value();
    }
    return state;
  },

  [API_DELETED]: (state, { payload: { resource, endpoint } }) => {
    if (endpoint.substring(0, 4) === API_PREFIX) {
      const type = endpoint.split(/\W+/)[1];

      return removeResourceFromState(state, resource, type)
        .set('isDeleting', state.isDeleting - 1)
        .value();
    }
    return state;
  },

  [API_DELETE_FAILED]: (state, { payload: { resource, endpoint } }) => {
    if (endpoint.substring(0, 4) === API_PREFIX) {
      const type = endpoint.split(/\W+/)[1];
      const { _id } = resource;

      return setIsInvalidatingForExistingResource(state, { type, _id }, IS_DELETING)
        .set('isDeleting', state.isDeleting + 1)
        .value();
    }
    return state;
  },

  [API_CLEAR]: (state, { payload: { resource } }) => {
    const { type } = resource;
    const newState = Object.assign({}, state);
    if (_.has(newState, type)) {
      delete newState[type];
    }

    return imm(newState)
      .value();
  },

  [RESET_AFFILIATE]: () => Object.assign({}, defaultState),

  [USER_LOGOUT]: () => Object.assign({}, defaultState),
}, Object.assign({}, defaultState));

export default menu;



// WEBPACK FOOTER //
// ./src/state/reducers/menu.js